var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"langsx"},[_c('v-select',{attrs:{"items":_vm.langItems,"value":_vm.currentLang,"label":_vm.$t('lang'),"outlined":""},on:{"change":function($event){return _vm.switchLang($event)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }